// src/router.js

import * as React from 'react';
import { createBrowserRouter } from 'react-router-dom';



// import { homeLoader } from './RouteLoader/authLoader';
import { CityProvider } from './Context/CityContext';
import { CityProviderForUser } from './user view src/Context/CityContext';













const Home = React.lazy(() => import('./views/Home/Home'));
const ExploreCities = React.lazy(() => import('./views/Home/Home2'));
const EditCity = React.lazy(() => import('./views/City/EditCity'));
const City = React.lazy(() => import('./user view src/views/City/City'));
const SignUp = React.lazy(() => import('./views/Auth/SignUp'));
const AdditionalInfo = React.lazy(() => import('./views/Auth/AdditionalInfo'));
const ForgotPassword = React.lazy(() => import('./views/Auth/ForgotPassword/ForgotPassword'));
const Dashboard = React.lazy(() => import('./views/Dashboard/Dashboard'));
const InfluencerSignUp = React.lazy(() => import('./views/Auth/InfluencerSignUp'));
const MultiImageUploader = React.lazy(() => import('./user view src/Multiupload'));
const TopMarkerEditor = React.lazy(() => import('./user view src/MultiUploadEdit'));
const TourismPlannerChat = React.lazy(() => import('./views/guideAi/guideai'));
const BulkUpload = React.lazy(() => import('./views/Post/BulkReels'));
const Login = React.lazy(() => import('./views/Auth/Login'));
const ReelViewer = React.lazy(() => import('./views/Reel/ReelViewer'));
const JoinItinerary = React.lazy(() => import('./views/Itinerary/JoinItinerary'));
const CropImage = React.lazy(() => import('./views/City/CropImage'));

const router = createBrowserRouter([
  { path: '/explore-cities', element: <ExploreCities /> },
  {
    path: '/',
    element: <Home />,
    // loader: homeLoader,
  },
  {
    path: '/login',
    element:<Login/>
  },
  {
    path: '/chat',
    element:<TourismPlannerChat/>,
    // loader: homeLoader,
  },
  {
    path: '/multi/:cityId',
    element: <MultiImageUploader/>,
    // loader: homeLoader,
  },
  {
    path: '/multiedit/:id',
    element: <TopMarkerEditor/>,
    // loader: homeLoader,
  },
  {
    path: '/signup',
    element: <SignUp />,
    // loader: homeLoader,
  },
  {
    path: '/join-as-influencer',
    element: <InfluencerSignUp />
  },

  {
    path: '/forgot-password',
    element: <ForgotPassword />,
    // loader: homeLoader,
  },

  {
    path: '/addinfo',
    element: <AdditionalInfo />,
  },
  {
    path: '/admin',
    element: <Dashboard />,
  },

  {
    path: '/city/:cityId',
    element:  (
      <CityProvider>
        <EditCity />
      </CityProvider>
    ), 
  },
  {
    path: '/:cityName',
    element:  (
      <CityProviderForUser>
        <City />
      </CityProviderForUser>
    ), 
  },
  {
    path: '/bulkReel',
    element: <BulkUpload/>
  },
  {
    path: '/itinerary/join/:token',
    element: <JoinItinerary />,
  },
  {
  path: '/posts/:id',
  element: <ReelViewer />,
},
  {
  path: '/reel/:id',
  element: <ReelViewer />,
},
  {
    path: '/crop-tool',
    element: <CropImage />,
  },
]);

export default router;
